/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_HotelInputs */

const en_map_hotel = /** @type {(inputs: Map_HotelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hotel`)
};

const fr_map_hotel = /** @type {(inputs: Map_HotelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hôtel`)
};

const ms_sg2_map_hotel = /** @type {(inputs: Map_HotelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hotel`)
};

/**
* | output |
* | --- |
* | "Hotel" |
*
* @param {Map_HotelInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const map_hotel = /** @type {((inputs?: Map_HotelInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_HotelInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_map_hotel(inputs)
	if (locale === "fr") return fr_map_hotel(inputs)
	return ms_sg2_map_hotel(inputs)
});